import type { MachineSummary } from '../types/machine';

type LifecycleAction = 'archive' | 'restore';

export function MachineLifecycleDialog({
  action,
  machine,
  busy,
  error,
  onCancel,
  onConfirm,
}: {
  action: LifecycleAction;
  machine: MachineSummary;
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const restoring = action === 'restore';
  return (
    <div className="r42-dialog-layer" role="dialog" aria-modal="true" aria-labelledby="machine-lifecycle-title" aria-describedby="machine-lifecycle-description">
      <button className="r42-dialog-backdrop" type="button" aria-label="Close machine lifecycle confirmation" onClick={busy ? undefined : onCancel} />
      <div className="r42-dialog-card r42-machine-lifecycle-dialog">
        <span className="r42-eyebrow">Machine lifecycle</span>
        <h2 id="machine-lifecycle-title">{restoring ? `Restore ${machine.name}?` : `Archive ${machine.name}?`}</h2>
        <p id="machine-lifecycle-description">
          {restoring
            ? 'This machine will return to your active workspace. Its existing Machine Memory, documents, conversations, investigations, and history will be available where your team left them.'
            : 'This machine will leave your active workspace and new activity will pause. Route42 will preserve its Machine Memory, documents, conversations, investigations, and history so you can restore it later.'}
        </p>
        <div className="r42-machine-lifecycle-safety-note">
          <i className="bi bi-shield-check" aria-hidden="true" />
          <span>{restoring ? 'Restoring does not recreate or reset the machine.' : 'Archiving does not delete machine knowledge.'}</span>
        </div>
        {error ? (
          <div className="r42-form-alert" role="alert">
            <i className="bi bi-exclamation-circle" aria-hidden="true" />
            <div><strong>Route42 could not complete this change.</strong><span>{error}</span></div>
          </div>
        ) : null}
        <div className="r42-dialog-actions">
          <button className="btn btn-outline-secondary" type="button" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className={`btn ${restoring ? 'r42-btn-primary' : 'r42-btn-archive'}`} type="button" onClick={onConfirm} disabled={busy}>
            {busy ? 'Working…' : restoring ? 'Restore machine' : 'Archive machine'}
          </button>
        </div>
      </div>
    </div>
  );
}
